export default function Aprops(props)
{
    return(
        <>
            <div className="Apropos"> 
                <h2>À Propos</h2>
                <p>Patati patata</p>
            </div>
        </>
    );
}